export const updateInfractionService = (fetch) => async (infraction) => {
  try {
    const response = await fetch({
      url: `/api/v1/infracciones/${infraction.id}`,
      method: "put",
      body: infraction,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
